module.exports = __webpack_public_path__ + "img/btn-offwork.0a62fd12.png";